import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { i18n, getLocale } from 'core/i18n';
import Tools from 'core/tools';
import SideMenu from 'components/sideMenu';
import Dialog from 'components/dialog/index';
import InputField from 'components/inputField/index';
import Select from 'components/reactSelect/index';
import Button from 'components/button/index';

import './profile.css';

import {
  getAgent,
  putAgent,
  clearProfile,
  updateAgentInfo
} from './action';

class ProfileIndex extends Component {
  constructor(props) {
    super(props);
    this.handleSelectDefault = this.handleSelectDefault.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    
    this.state = {
      pwEditable: false
    };
  }

  componentDidMount() {
    const self = this,
      { props } = self,
      { dispatch = () => { } } = props;
    
    dispatch(getAgent());
  }

  componentWillUnmount() {
     const self = this,
      { props } = self,
      { dispatch = () => { } } = props;
    
    dispatch(clearProfile());
  }

  handleSelectDefault(options, value) {
		let defaultValue = null;

		if (options) {
			for (let i = 0; i < options.length; i++) {
				if (options[i].value === value) {
					defaultValue = options[i];
					break;
				}
			}
		}
		
		return defaultValue;
	}

  handleSelectChange(type, value) {
    const self = this,
			{
				props
			} = self,
			{
				state,
				dispatch = () => { }
			} = props,
			{
				agentInfo
			} = state;
    let newAgentInfo = JSON.parse(JSON.stringify(agentInfo));
    
    switch (type) {
      case 'mobilePhone_dialCode':
        newAgentInfo.mobilePhone.dialCode = value;
        break;
      case 'workPhone_dialCode':
        newAgentInfo.workPhone.dialCode = value;
        break;
      default:
        newAgentInfo[type] = value;
        break;
    }

    dispatch(updateAgentInfo(newAgentInfo));
  }

  handleInputChange(type, value) {
    const self = this,
			{
				props
			} = self,
			{
				state,
				dispatch = () => { }
			} = props,
			{
				agentInfo
			} = state;
    let newAgentInfo = JSON.parse(JSON.stringify(agentInfo));
    
    switch (type) {
      case 'mobilePhone_number':
        newAgentInfo.mobilePhone.number = value;
        break;
      case 'workPhone_number':
        newAgentInfo.workPhone.number = value;
        break;
      default:
        newAgentInfo[type] = value;
        break;
    }

    dispatch(updateAgentInfo(newAgentInfo));
  }

  render() {
    const self = this,
      {
        props,
        state: _state,
        handleSelectDefault = () => { },
        handleSelectChange = () => { },
        handleInputChange = () => { }
      } = self,
      {
        state,
        mainState,
        dispatch = () => { }
      } = props,
      {
        agentInfo,
        errors,
        showSuccessDialog
      } = state,
      {
        balanceInfo,
        langOptions,
        currencyOptions,
        titleOptions,
        dialCodeOptions,
        countryCodeOptions
      } = mainState,
      {
        pwEditable
      } = _state;
    
    return (
      <div className='profile-container'>
        {/* success dialog */}
        <Dialog
          dialogId='profile-success-dialog'
          maxWidth='xs'
          zIndex={2000}
          open={!!showSuccessDialog}
          onClose={() => {
            // 初始化捲軸位置
            if (typeof window !== 'undefined') {
              window.scrollTo({ top: 0, left: 0 });
            }
            let url = Tools.generateLocaleUrl(getLocale(), '/Home')
            props.history.push(url);
          }}
          title={i18n('success_heading')}
          actionsClassName='profile-success-dialog-action'
          actions={[
            <Button
              size='large'
              className={'close-button'}
              onClick={() => {
                // 初始化捲軸位置
                if (typeof window !== 'undefined') {
                  window.scrollTo({ top: 0, left: 0 });
                }
                let url = Tools.generateLocaleUrl(getLocale(), '/Home')
                props.history.push(url);
              }}
            >
              {i18n('close')}
            </Button>
          ]}
        >
          <div className='profile-success-dialog-body'>{i18n('success_message_update')}</div>
        </Dialog>
        <div className='area-left'>
          <div className='profile-header'>{i18n('my_profile')}</div>
          {
            agentInfo ? (
              <div className='profile-body'>
                {/* 登入資訊 */}
                <div className='profile-panel'>
                  <div className='profile-panel-title'>
                    <img alt='' src={require('assets/images/passenger.svg')} />
                    <span>{i18n('login_info')}</span>
                  </div>
                  <div className='profile-panel-content'>
                    <div className='profile-panel-row'>
                      {/* 旅行社組織 */}
                      <div className='profile-panel-item'>
                        <div className='profile-panel-label'>{i18n('login_info_org_code')}</div>
                        <InputField
                          disabled={true}
                          onBlurActEvent={(data) => {
                            handleInputChange('organizationCode', data);
                          }}
                          defaultValue={agentInfo.organizationCode || ''}
                          validateMessage={errors && errors.organizationCode ? i18n('error_organization_name') : null}
                        />
                      </div>
                      {/* Skyagent 登入帳號 */}
                      <div className='profile-panel-item'>
                        <div className='profile-panel-label'>{i18n('login_info_agent_id')}</div>
                        <InputField
                          disabled={true}
                          onBlurActEvent={(data) => {
                            handleInputChange('agentName', data);
                          }}
                          defaultValue={agentInfo.agentName || ''}
                          validateMessage={errors && errors.agentName ? i18n('error_skyagent_name') : null}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {/* 設定 */}
                <div className='profile-panel setting'>
                  <div className='profile-panel-title'>
                    <img alt='' src={require('assets/images/setting.svg')} />
                    <span>{i18n('settings')}</span>
                  </div>
                  <div className='profile-panel-content'>
                    <div className='profile-panel-row'>
                      {/* 幣值 */}
                      <div className='profile-panel-item'>
                        <div className='profile-panel-label'>{i18n('settings_currency')}</div>
                        <Select
                          id={'profile-currency'}
                          isSearchable={false}
                          isDisabled={true}
                          placeholder={agentInfo.preferredCurrency}
                          defaultValue={handleSelectDefault(currencyOptions, agentInfo.preferredCurrency)}
                          options={currencyOptions}
                          onChangeEvent={(data) => {
                            handleSelectChange('preferredCurrency', data.value);
                          }}
                          errorText={errors && errors.preferredCurrency ? i18n('error_preferred_currency') : null}
                        />
                      </div>
                      {/* 語言 */}
                      <div className='profile-panel-item'>
                        <div className='profile-panel-label'>{i18n('settings_language')}</div>
                        <Select
                          id={'profile-language'}
                          isSearchable={false}
                          placeholder={i18n('placeholder')}
                          defaultValue={handleSelectDefault(langOptions, agentInfo.preferredLanguage)}
                          options={langOptions}
                          onChangeEvent={(data) => {
                            handleSelectChange('preferredLanguage', data.value);
                          }}
                          errorText={errors && errors.preferredLanguage ? i18n('error_preferred_language') : null}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {/* 聯絡人詳細資訊 */}
                <div className='profile-panel contact'>
                  <div className='profile-panel-title'>
                    <img alt='' src={require('assets/images/passenger.svg')} />
                    <span>{i18n('contact')}</span>
                  </div>
                  <div className='profile-panel-content'>
                    <div className='profile-panel-row'>
                      <div className='profile-panel-item width-fifty'>
                        {/* 稱謂 */}
                        <div>
                          <div className='profile-panel-label'>{i18n('contact_title')}</div>
                          <Select
                            id={'profile-title'}
                            isSearchable={false}
                            placeholder={i18n('placeholder')}
                            defaultValue={handleSelectDefault(titleOptions, agentInfo.title)}
                            options={titleOptions}
                            onChangeEvent={(data) => {
                              handleSelectChange('title', data.value);
                            }}
                            errorText={errors && errors.title ? i18n('error_title') : null}
                          />
                        </div>
                        {/* 名字 */}
                        <div>
                          <div className='profile-panel-label'>{i18n('first_name')}</div>
                          <InputField
                            inputType={'name'}
                            onBlurActEvent={(data) => {
                              handleInputChange('firstName', data);
                            }}
                            defaultValue={agentInfo.firstName || ''}
                            validateMessage={errors && errors.firstName ? i18n('error_first_name') : null}
                          />
                        </div>
                      </div>
                      {/* 姓氏 */}
                      <div className='profile-panel-item'>
                        <div className='profile-panel-label'>{i18n('last_name')}</div>
                        <InputField
                          inputType={'name'}
                          onBlurActEvent={(data) => {
                            handleInputChange('lastName', data);
                          }}
                          defaultValue={agentInfo.lastName || ''}
                          validateMessage={errors && errors.lastName ? i18n('error_last_name') : null}
                        />
                      </div>
                    </div>
                    <div className='profile-panel-row'>
                      {/* 手機號碼 */}
                      <div className='profile-panel-item width-fifty'>
                        <div>
                          <div className='profile-panel-label'>{i18n('contact_mobile_number')}</div>
                          <Select
                            id={'profile-mobile-dial-code'}
                            placeholder={i18n('placeholder')}
                            defaultValue={handleSelectDefault(dialCodeOptions[getLocale()], agentInfo.mobilePhone.dialCode)}
                            options={dialCodeOptions[getLocale()]}
                            onChangeEvent={(data) => {
                              handleSelectChange('mobilePhone_dialCode', data.value);
                            }}
                            errorText={errors && errors.mobilePhone && errors.mobilePhone.dialCode ? i18n('error_mobile_code') : null}
                          />
                        </div>
                        <div>
                          <div className='profile-panel-label'></div>
                          <InputField
                            inputType={'tel'}
                            onBlurActEvent={(data) => {
                              handleInputChange('mobilePhone_number', data);
                            }}
                            defaultValue={agentInfo.mobilePhone.number || ''}
                            validateMessage={errors && errors.mobilePhone && errors.mobilePhone.number ? i18n('error_mobile_number') : null}
                          />
                        </div>
                      </div>
                      {/* 公司電話 */}
                      <div className='profile-panel-item width-fifty'>
                        <div>
                          <div className='profile-panel-label'>{i18n('contact_office_number')}</div>
                          <Select
                            id={'profile-office-dial-code'}
                            placeholder={i18n('placeholder')}
                            defaultValue={handleSelectDefault(dialCodeOptions[getLocale()], agentInfo.workPhone.dialCode)}
                            options={dialCodeOptions[getLocale()]}
                            onChangeEvent={(data) => {
                              handleSelectChange('workPhone_dialCode', data.value);
                            }}
                            errorText={errors && errors.workPhone && errors.workPhone.dialCode ? i18n('error_office_code') : null}
                          />
                        </div>
                        <div>
                          <div className='profile-panel-label'></div>
                          <InputField
                            inputType={'tel'}
                            onBlurActEvent={(data) => {
                              handleInputChange('workPhone_number', data);
                            }}
                            defaultValue={agentInfo.workPhone.number || ''}
                            validateMessage={errors && errors.workPhone && errors.workPhone.number ? i18n('error_office_number') : null}
                          />
                        </div>
                      </div>
                    </div>
                    <div className='profile-panel-row'>
                      {/* 電子郵件 */}
                      <div className='profile-panel-item'>
                        <div className='profile-panel-label'>{i18n('contact_email')}</div>
                        <InputField
                          inputType={'email'}
                          maxLength={'50'}
                          onBlurActEvent={(data) => {
                            handleInputChange('email', data);
                          }}
                          defaultValue={agentInfo.email || ''}
                          validateMessage={errors && errors.email ? i18n('error_email') : null}
                        />
                      </div>
                      {/* 確認電子郵件 */}
                      <div className='profile-panel-item'>
                        <div className='profile-panel-label'>{i18n('contact_confirm_email')}</div>
                        <InputField
                          inputType={'email'}
                          maxLength={'50'}
                          onBlurActEvent={(data) => {
                            handleInputChange('confirmEmail', data);
                          }}
                          defaultValue={agentInfo.confirmEmail || ''}
                          validateMessage={errors && errors.confirmEmail ? i18n('error_confirm_email') : null}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {/* 地址 */}
                <div className='profile-panel address'>
                  <div className='profile-panel-title'>
                    <img alt='' src={require('assets/images/address.svg')} />
                    <span>{i18n('address')}</span>
                  </div>
                  <div className='profile-panel-content'>
                    <div className='profile-panel-row'>
                      {/* 地址 1 */}
                      <div className='profile-panel-item'>
                        <div className='profile-panel-label'>{i18n('address_line_1')}</div>
                        <InputField
                          maxLength={'52'}
                          onBlurActEvent={(data) => {
                            handleInputChange('address1', data);
                          }}
                          defaultValue={agentInfo.address1 || ''}
                          validateMessage={errors && errors.address1 ? i18n('error_address_1') : null}
                        />
                      </div>
                      {/* 地址 2 */}
                      <div className='profile-panel-item'>
                        <div className='profile-panel-label'>{i18n('address_line_2')}</div>
                        <InputField
                          maxLength={'52'}
                          onBlurActEvent={(data) => {
                            handleInputChange('address2', data);
                          }}
                          defaultValue={agentInfo.address2 || ''}
                          // validateMessage={errors && errors.address2 ? i18n('error_address_2') : null}
                        />
                      </div>
                    </div>
                    <div className='profile-panel-row'>
                      {/* 城鎮 */}
                      <div className='profile-panel-item'>
                        <div className='profile-panel-label'>{i18n('address_city')}</div>
                        <InputField
                          onBlurActEvent={(data) => {
                            handleInputChange('city', data);
                          }}
                          defaultValue={agentInfo.city || ''}
                          validateMessage={errors && errors.city ? i18n('error_city') : null}
                        />
                      </div>
                      {/* 國家 */}
                      <div className='profile-panel-item'>
                        <div className='profile-panel-label'>{i18n('address_country')}</div>
                        <Select
                          id={'profile-country'}
                          placeholder={i18n('placeholder')}
                          defaultValue={handleSelectDefault(countryCodeOptions[getLocale()], agentInfo.country)}
                          options={countryCodeOptions[getLocale()]}
                          onChangeEvent={(data) => {
                            handleSelectChange('country', data.value);
                          }}
                          errorText={errors && errors.country ? i18n('error_country') : null}
                        />
                      </div>
                    </div>
                    <div className='profile-panel-row'>
                      {/* 郵遞區號 */}
                      <div className='profile-panel-item'>
                        <div className='profile-panel-label'>{i18n('address_postal_code')}</div>
                        <InputField
                          onBlurActEvent={(data) => {
                            handleInputChange('postalCode', data);
                          }}
                          defaultValue={agentInfo.postalCode || ''}
                          // validateMessage={errors && errors.postalCode ? i18n('error_postal_code') : null}
                        />
                      </div>
                      <div className='profile-panel-item'></div>
                    </div>
                  </div>
                </div>
                {/* 密碼 */}
                <div className='profile-panel'>
                  <div className='profile-panel-title mima'>
                    <div>
                      <img alt='' src={require('assets/images/password.svg')} />
                      <span>{i18n('password')}</span>
                    </div>
                    <Button
                      className={'primary-button change-mima-btn'}
                      onClick={() => {
                        let newAgentInfo = JSON.parse(JSON.stringify(agentInfo));
                        
                        // 變更密碼，則新增key
                        if (!pwEditable) {
                          newAgentInfo.password = '';
                          newAgentInfo.confirmPassword = '';
                        } else { // 取消變更密碼，則刪除key
                          delete newAgentInfo.password;
                          delete newAgentInfo.confirmPassword;
                        }

                        dispatch(updateAgentInfo(newAgentInfo));

                        self.setState({
                          pwEditable: !pwEditable
                        });
                      }}
                    >
                      {i18n('password_change_pw')}
                    </Button>
                  </div>
                  <div className='profile-panel-content'>
                    <div className='profile-panel-row'>
                      {/* 新密碼 */}
                      <div className='profile-panel-item'>
                        <div className='profile-panel-label'>{i18n('password_new_pw')}</div>
                        <InputField
                          type={'password'}
                          inputType={'password'}
                          disabled={!pwEditable}
                          maxLength={'16'}
                          value={!pwEditable ? '' : agentInfo.password}
                          onBlurActEvent={(data) => {
                            handleInputChange('password', data);
                          }}
                          validateMessage={pwEditable && errors && errors.password ? i18n('error_password') : null}
                        />
                      </div>
                      {/* 確認密碼 */}
                      <div className='profile-panel-item'>
                        <div className='profile-panel-label'>{i18n('password_confirm_pw')}</div>
                        <InputField
                          type={'password'}
                          inputType={'password'}
                          disabled={!pwEditable}
                          maxLength={'16'}
                          value={!pwEditable ? '' : agentInfo.confirmPassword}
                          onBlurActEvent={(data) => {
                            handleInputChange('confirmPassword', data);
                          }}
                          validateMessage={pwEditable && errors && errors.confirmPassword ? i18n('error_confirm_password') : null}
                        />
                      </div>
                    </div>
                    <div className='profile-panel-instruction'>{`* ${i18n('password_instruction')}`}</div>
                  </div>
                </div>
                {/* 儲存 */}
                <div className='profile-panel-button'>
                  <Button
                    className={'primary-button'}
                    onClick={() => {
                      dispatch(putAgent(agentInfo));
                    }}
                  >
                    {i18n('save')}
                  </Button>
                </div>
              </div>
            ) : null
          }
        </div>
        <SideMenu
          balanceInfo={balanceInfo}
        />
      </div>
    );
  }
}

let mapStateToProps = (state) => {

  return {
    state: state.profileReducer,
    mainState: state.mainReducer
  };
};

export default connect(mapStateToProps)(withRouter(ProfileIndex));